export default "assets/images/button-mask-a259a4b6.svg";